"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryFundingFeeRecord = exports.queryTransferRecords = void 0;
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../interface");
const utils_1 = require("./utils");
/**查询跨账户转账记录 */
function queryTransferRecords(params) {
    const instance = (0, trade_utils_lib_1.getTradeDependencyInstance)();
    const host = instance.getRunTimeHost().walletApiHost;
    const url = host + "/transfer_records/";
    return trade_utils_lib_1.NetworkUtils.getWithAccessAndSpotAuth({ url, data: params }).pipe((0, operators_1.map)((resp) => ((resp === null || resp === void 0 ? void 0 : resp.records) || []).filter((it) => it.status !== interface_1.TransferStatus.FAILED)));
}
exports.queryTransferRecords = queryTransferRecords;
/**查询当前账户资金费 */
function queryFundingFeeRecord(request) {
    return (0, utils_1.requestWithSignV2)({
        accountType: request.accountType,
        api: "/trade/funding_fee",
        method: "GET",
        query: request,
    }).pipe((0, operators_1.map)((resp) => 
    // 生成唯一的virtualKey，用于渲染
    (0, utils_1.processPageCursorData)(resp, "fundings").map((it, index) => (Object.assign(Object.assign({}, it), { virtualKey: `${it.symbol}_${it.timestamp}_${index}` })))));
}
exports.queryFundingFeeRecord = queryFundingFeeRecord;
